import React from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './styles.css';

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <Header />
      <div className="error-container">
        <h1>Ops!</h1>
        <h2>Página não encontrada</h2>
        <p>
          {error?.statusText || error?.message || 
           'Desculpe, não conseguimos encontrar a página que você está a procurar'}
        </p>
        <div className="error-actions">
          <button onClick={() => navigate(-1)} className="back-button">
            Voltar
          </button>
          <button onClick={() => navigate('/')} className="home-button">
            Ir para a página inicial
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorPage; 